exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tablaarticulos table td:first-child{width:125px}.tablaarticulos table td:nth-child(2){width:90px}.tablaarticulos table td:nth-last-child(2){width:150px}.tablaarticulos table td:last-child{width:200px}", ""]);

// exports
